import Card from '@mui/material/Card';
import { darken, lighten } from '@mui/material/styles';

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.8);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.6);

const StyledDataGrid = ({children}) => {
    return (
        <Card
          sx={{
            width: '100%',
            '& .super-order-theme-t0': {
              bgcolor: (theme) =>
                getBackgroundColor(theme.palette.info.main, theme.palette.mode),
              '&:hover': {
                bgcolor: (theme) =>
                  getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
              },
            },
            '& .super-order-theme-t1': {
              bgcolor: (theme) =>
                getBackgroundColor(theme.palette.success.main, theme.palette.mode),
              '&:hover': {
                bgcolor: (theme) =>
                  getHoverBackgroundColor(
                    theme.palette.success.main,
                    theme.palette.mode,
                  ),
              },
            },
            '& .super-order-theme-t2': {
              bgcolor: (theme) =>
                getBackgroundColor(theme.palette.warning.main, theme.palette.mode),
              '&:hover': {
                bgcolor: (theme) =>
                  getHoverBackgroundColor(
                    theme.palette.warning.main,
                    theme.palette.mode,
                  ),
              },
            },
            '& .super-order-theme-t3': {
              bgcolor: (theme) =>
                getBackgroundColor(theme.palette.error.main, theme.palette.mode),
              '&:hover': {
                bgcolor: (theme) =>
                  getHoverBackgroundColor(theme.palette.error.main, theme.palette.mode),
              },
            },
            '& .super-order-edit--cell': {
              backgroundColor: '#f6f6f6',
              color: '#1a3e72',
              fontWeight: '600',
              padding: '10px',
              // border: '1px solid #f6f7f8',
            },
            "& .MuiDataGrid-cell": {              
              minWidth: "120px",
            },
          }}
        >
            {children}
        </Card>
    );
}

export default StyledDataGrid